// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const WrapTextIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="WrapTextIcon" ref={forwardedRef} {...props}>
      <path d="M3 10.498v-1.5h13a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-5V14h4.504v-3.502z" />
      <path d="M7 14H3v1.498h4z" />
      <path d="M3.004 3.998h14v1.5h-14z" />
      <path d="M12.078 17.578 9.25 14.75l2.828-2.828 1.063 1.062-1.77 1.77 1.766 1.765z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const WrapTextIcon = /* @__PURE__ */ Object.assign(
  WrapTextIconComponent,
  { displayName: 'WrapTextIcon' },
);
